import React from 'react'
import PropTypes from 'propTypes'
import { cx } from '@emotion/css'
import { withRouter } from 'react-router-dom'
import styles from './styles'

const AdminPanel = ({ hubspotUrl, companyId, location }) => {
  let candidateId
  const params = location.pathname.split('/')
  if (params && params[params.length - 2] === 'candidates' && params[params.length - 1]) {
    candidateId = params[params.length - 1]
  }
  return (
    <div className={styles.adminLinksContainer}>
      <If condition={candidateId}>
        <a className={cx(styles.taraAdminLink, styles.candidatesLink)} href={`/tara/portfolio/${candidateId}/profile`}>
          Tara candidate profile
        </a>
      </If>
      <If condition={companyId}>
        <a className={cx(styles.taraAdminLink, styles.companiesLink)} href={`/tara/companies/${companyId}`}>
          Tara company profile
        </a>
      </If>
      <If condition={hubspotUrl}>
        <a className={cx(styles.taraAdminLink, styles.hubspotLink)} href={hubspotUrl} target="_blank" rel="noreferrer">
          Hubspot
        </a>
      </If>
    </div>
  )
}

export default withRouter(AdminPanel)

const { shape, string } = PropTypes
AdminPanel.propTypes = {
  hubspotUrl: string,
  companyId: string,
  location: shape({
    pathname: string,
  }),
}
